/**
 * @fileoverview GET handler for the "/email/ip_warming/:app_group_id/show_ip_warming_widget" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { emailIpWarmingAppGroupIdShowIpWarmingWidget } from "./constants";
import type { GetEmailIpWarmingAppGroupIdShowIpWarmingWidgetResult } from "./types";
import { isGetEmailIpWarmingAppGroupIdShowIpWarmingWidgetResult } from "./validators";

export const getEmailIpWarmingAppGroupIdShowIpWarmingWidget = reactQueryFetcherAdapter(
  emailIpWarmingAppGroupIdShowIpWarmingWidget,
  (signal: AbortSignal, appGroupId: string): Promise<GetEmailIpWarmingAppGroupIdShowIpWarmingWidgetResult> => {
    return fetch(`/email/ip_warming/${appGroupId}/show_ip_warming_widget`, "GET", {}, { signal });
  },
  isGetEmailIpWarmingAppGroupIdShowIpWarmingWidgetResult
);
